import React from 'react';
import "../styles/styles.css";

const DashBoardFooter = () => {
  return (
    <>
    <p className='footerBottomBar'>© My Local Merchant Services - 2018-2020. All rights reserved.</p>
    </>
  )
}

export default DashBoardFooter;